import React, { useEffect, useState } from "react";
import {
  formatDateTimeUtc,
  LoadingDiv,
  SweetAlertShow,
} from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import { esslDevicesLogs } from "../../../api/EsslDevice";

export default function DevicesLogs() {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);

  const getDevicesLogs = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value) {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      const response = await esslDevicesLogs(addUrl);
      if (response?.data?.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDevicesLogs();
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                            <h4 className="mb-0">Devices Logs</h4>
                          </div>
                          <div className="col-12">
                            <hr />
                          </div>
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search..."
                                value={filters?.search}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    search: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="">Search</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Registration No</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Punch Time</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.length > 0 &&
                                data?.map((item, index) => (
                                  <tr key={item?.DeviceLogId}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {item?.user_type} |{" "}
                                      {item?.registration_no}
                                    </td>
                                    <td>{item?.name}</td>
                                    <td>{item?.mobile}</td>
                                    <td>{formatDateTimeUtc(item?.LogDate)}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
